
export default {
    name: "falcon-ad",
    props: {
        adSlot: Number,
        ratio: Number,
        radius: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            adElement: null,
            adHeight: null
        }
    },
    watch: {
        adElement: function () {
            this.adHeight = this.adElement.clientWidth * this.ratio;
        }
    },
    mounted() {
        this.adElement = this.$refs.adElement;
    }
}
